<template>
  <div class="home-ds ds-scope homeLayout" :data-testid="TEST_ID.HOME.ROOT">
    <div class="homeContent">
      <div class="homeGrid">
        <div class="homeGridMain">
          <div v-if="shouldRenderAvisosImportantes" class="homePanel homeImportantNotices" :data-testid="TEST_ID.HOME.SECTION_AVISOS_IMPORTANTES">
            <DsAvisosImportantes :avisos="avisosImportantes" />
          </div>

          <div class="homePanel homePanelMain homeNewsSection" :data-testid="TEST_ID.HOME.SECTION_NOTICIAS">
            <div class="sectionTitle ds-h3">{{ $t('NOTICIAS_noticias') }}</div>
            <DsNoticia :data="noticias" />
          </div>
        </div>

        <div class="homeGridAside">
          <div class="homePanel" :data-testid="TEST_ID.HOME.SECTION_ARCHIVOS">
            <div class="sectionTitle">
              <el-row>
                <el-col :span="8" class="ds-h3">{{ $t('ARCHIVOS_archivos') }}</el-col>
              </el-row>
            </div>
            <el-row>
              <div v-if="cargandoArchivos" class="loader">
                <el-icon class="is-loading primary"><Loading /></el-icon>
                <div class="primary text-loader ds-body-small">{{ $t('GENERAL_cargando') }} {{ $t('ARCHIVOS_archivos') }}</div>
              </div>
              <div v-else class="homeFilesContainer">
                <el-tree
                  class="nodeTree"
                  :data="dataFiles"
                  :props="defaultProps"
                  node-key="Id"
                  ref="tree"
                >
                  <template #default="{ node, data }">
                    <span class="homeFileItem">
                      <span v-if="data.EsArchivo" class="homeFileItem__row homeFileItem__text">
                        <el-icon class="iconFile"><component :is="data.TipoArchivo == 1 ? 'Document' : 'Paperclip'" /></el-icon>
                        <span class="homeFileItem__label" :data-testid="TEST_ID.HOME.ITEM_ARCHIVO_LABEL" :title="node.label">{{ node.label }}</span>
                        <span v-if="node.isLeaf == true" class="homeFileItem__actions">
                          <el-icon v-if="!descargandoArchivo" class="iconFile" @click="data.TipoArchivo == 1 ? downloadArchivo(data.Id) : abrirEnlace(data.Id)"><component :is="data.TipoArchivo == 1 ? 'Download' : 'TopRight'" /></el-icon>
                          <el-icon v-else class="is-loading primary"><Loading /></el-icon>
                        </span>
                      </span>

                      <span v-else class="homeFileItem__row homeFileItem__text">
                        <span v-if="data.EstaVacio == true" class="leyenda homeFileItem__label">{{ $t('ARCHIVOS_carpeta_vacia') }}</span>
                        <span v-else class="homeFileItem__folder" @click="getHijos(data, node)">
                          <el-icon class="iconFile"><Folder /></el-icon>
                          <span class="homeFileItem__label" :data-testid="TEST_ID.HOME.ITEM_ARCHIVO_LABEL" :title="node.label">{{ node.label }}</span>
                        </span>
                        <span class="homeFileItem__actions">
                          <el-icon v-if="!descargandoArchivo" class="iconFile" @click="downloadArchivo(data.Id)"><Download /></el-icon>
                          <el-icon v-else class="is-loading primary"><Loading /></el-icon>
                        </span>
                      </span>
                    </span>
                  </template>
                </el-tree>
              </div>
            </el-row>
          </div>

          <el-row class="homeForosRow">
            <div class="homePanel" :data-testid="TEST_ID.HOME.SECTION_FORO">
              <div class="sectionTitle">
                <el-row>
                  <el-col :span="8" class="ds-h3">{{ $t('FORO_foros') }}</el-col>

                  <el-col :span="16" class="homeForoPager">
                    <el-pagination
                      background
                      :small="true"
                      layout="prev, pager, next"
                      :total="paginadorForos.totalObjects"
                      :page-size="paginadorForos.pageSize"
                      :pager-count="5"
                      hide-on-single-page
                      @current-change="onForoPageChange"
                    />
                  </el-col>
                </el-row>
              </div>

              <div v-if="cargandoForos" class="loader">
                <el-icon class="is-loading primary"><Loading /></el-icon>
                <div class="primary text-loader ds-body-small">{{ $t('GENERAL_cargando') }} {{ $t('FORO_foros') }}</div>
              </div>
              <div v-else>
                <Foros :data="foros" />
              </div>
            </div>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DsNoticia from '../ds/DsNoticia'
import DsAvisosImportantes from '../ds/DsAvisosImportantes'
import Foros from './DsForo'
import { showError } from '../Mensaje'
import TEST_ID from '@/testIds.json'

const cantidadEntradas = 4

export default {
  name: 'DsHome',
  components: { DsNoticia, Foros, DsAvisosImportantes },

  data() {
    return {
      TEST_ID,
      noticias: [],
      avisosAbortController: null,
      archivos: undefined,
      foros: undefined,
      paginadorForos: {
        page: 0,
        pageSize: cantidadEntradas,
        totalObjects: 0
      },
      descargandoArchivo: false,
      cargandoArchivos: false,
      cargandoForos: false,
      dataFiles: undefined,
      defaultProps: {
        id: 'Id',
        children: 'Hijos',
        label: 'Nombre',
        isLeaf: 'EsArchivo',
        isEmpty: 'EstaVacio'
      }
    }
  },

  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      perfiles: state => state.sesion.resultadoAutenticacion.Perfiles,
      avisosImportantes: state => state.avisosImportantes.avisos,
      estadoAvisosImportantes: state => state.avisosImportantes.estado
    })
    ,
    shouldRenderAvisosImportantes() {
      return this.estadoAvisosImportantes === 'ready' && this.avisosImportantes.length > 0
    }
  },

  methods: {
    getNoticias() {
      this.$store.dispatch('noticias/getNoticiasPublicadas', { page: 0, pageSize: 1000 })
        .then(data => (this.noticias = data.Result))
    },
    async loadAvisosImportantes() {
      if (this.avisosAbortController) {
        this.avisosAbortController.abort()
      }

      const requestController = new AbortController()

      this.avisosAbortController = requestController

      try {
        await this.$store.dispatch('avisosImportantes/getAvisos', {
          usuarioId: this.idUsuario,
          controller: requestController
        })
      } catch (error) {
        console.error('[DsHome] Error inesperado al resolver avisos importantes.', error)
      } finally {
        if (this.avisosAbortController === requestController) {
          this.avisosAbortController = null
        }
      }
    },
    getHijos(nodo, nodoConfig) {
      if (!nodo.HijosCargados) {
          const payload = {
          idUsuario: this.idUsuario,
          idPerfiles: this.perfiles.map(x => x.Id),
          idNodo: nodo.Id
        }

        nodoConfig.loading = true
        this.$store.dispatch('archivos/getArchivosJerarquia', payload)
          .then(data => {
            nodo.HijosCargados = true
            nodo.Hijos = data.Datos
            if (nodo.Hijos.length === 0) {
              nodo.Hijos.push({ EstaVacio: true })
            }
            nodoConfig.expanded = true
          })
          .finally(() => {
            nodoConfig.loading = false
          })
      }
    },
    getArchivos() {
      const payload = {
        idUsuario: this.idUsuario,
        idPerfiles: this.perfiles ? this.perfiles.map(x => x.Id) : '',
        idNodo: undefined
      }

      this.cargandoArchivos = true
      this.$store.dispatch('archivos/getArchivosJerarquia', payload)
        .then(data => {
          this.archivos = data.Datos
          this.dataFiles = this.archivos
        })
        .finally(() => (this.cargandoArchivos = false))
    },
    getForos() {
      const payload = {
        page: this.paginadorForos.page,
        pageSize: this.paginadorForos.pageSize,
        cantidadEntradas: cantidadEntradas
      }

      this.cargandoForos = true
      this.$store.dispatch('foro/getUltimasEntradasForo', payload)
        .then(data => {
          this.foros = data.Result
          this.paginadorForos.totalObjects = data.TotalObjects
        })
        .finally(() => (this.cargandoForos = false))
    },
    onForoPageChange(page) {
      this.paginadorForos.page = page - 1
      this.getForos()
    },
    abrirEnlace(idFile) {
      this.descargandoArchivo = true
      this.$store.dispatch('archivos/getLink', { idArchivo: idFile }).then(response => {
        window.open(response, '_blank')
      }).catch(() => showError(this.$t('ARCHIVOS_error_descarga')))
        .finally(() => (this.descargandoArchivo = false))
    },
    downloadArchivo(idFile) {
      this.descargandoArchivo = true

      const payload = {
        idUsuario: this.idUsuario,
        idPerfiles: this.perfiles ? this.perfiles.map(x => x.Id) : '',
        idNodo: idFile
      }

      this.$store.dispatch('archivos/downloadFile', payload).then(response => {
        const mimeType = response.headers['content-type']
        const contentDisposition = response.headers['content-disposition']
        let fileName = contentDisposition.split('; filename=')[1]
        fileName = fileName.replace(/"/g, '')
        fileName = decodeURIComponent(fileName)

        const blob = new Blob([response.data], { type: mimeType })

        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob)
        } else {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.target = '_blank'
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }).catch(() => showError(this.$t('ARCHIVOS_error_descarga')))
        .finally(() => (this.descargandoArchivo = false))
    }
  },

  mounted() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.loadAvisosImportantes()
    this.getNoticias()
    this.getForos()
    this.getArchivos()
  },

  beforeUnmount() {
    if (this.avisosAbortController) {
      this.avisosAbortController.abort()
      this.avisosAbortController = null
    }
  }
}

</script>

<style src="./home.css"></style>
